import ProcessUploadArea from "./ProcessUploadArea";

export default ProcessUploadArea;